import script from "./WageSlipPdf.vue?vue&type=script&setup=true&lang=ts"
export * from "./WageSlipPdf.vue?vue&type=script&setup=true&lang=ts"

import "./WageSlipPdf.vue?vue&type=style&index=0&id=ac162c56&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac162c56"]])

export default __exports__